unit View.Nfe.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, System.StrUtils, UFrameDataBase, Vcl.Forms,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela, System.DateUtils,
  XData.Web.Client, UHelperServer;

type
  TFViewNfeList = class(TForm)
    NfeDataset: TXDataWebDataSet;
    NfeDatasetnfe_es: TIntegerField;
    NfeDatasetnfe_complementar: TBooleanField;
    NfeDatasetchave_acesso: TStringField;
    NfeDatasetnfe_transmissao: TDateTimeField;
    NfeDatasetvalor_total: TFloatField;
    NfeDatasetnfe_cancelada: TBooleanField;
    NfeDatasetxml_s3: TStringField;
    NfeDatasetcodigo_interno: TIntegerField;
    NfeDatasetexcluido: TBooleanField;
    NfeDatasetinclusao: TDateTimeField;
    NfeDatasetalteracao: TDateTimeField;
    NfeDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    NfeDatasetid: TIntegerField;
    NfeDatasetanexo_sincronizado: TIntegerField;
    btnExportarExcel: TButton;
    edtTransmissaoInicial: TDateTimePicker;
    edtTransmissaoFinal: TDateTimePicker;
    cbxNfeExcluidos: TCheckBox;
    cbxNfeCancelada: TCheckBox;
    frmBanco: TfrmDataBase;
    btnPesquisarNfe: TButton;
    XDataWebClient: TXDataWebClient;
    NfeDatasetnfe_lotecodigo_interno: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure NfeDatasetnfe_esGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnPesquisarNfeClick(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebClientLoad(Response: TXDataClientResponse);
    procedure btnExportarExcelClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;


    procedure ConfigurarData;
    function GetFiltro : string;
    function ValidarDatas : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfeList: TFViewNfeList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfeList }

procedure TFViewNfeList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(NfeDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewNfeList.btnPesquisarNfeClick(Sender: TObject);
begin
  ValidarDatas;
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNfeList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewNfeList.ConfigurarData;
begin
  edtTransmissaoFinal.Max := Date;
  edtTransmissaoInicial.Min := IncDay(Date, -365);
  edtTransmissaoInicial.Date := IncDay(Date, -365);
  edtTransmissaoFinal.Date := Date;
end;

class function TFViewNfeList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfeList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewNfeList, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfeList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewNfeList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewNfeList.GetFiltro: string;
var
  lListaFiltro : TStringList;
  lFiltroBanco : string;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;

  try
    if not cbxNfeExcluidos.Checked then
      lListaFiltro.Add('(excluido eq false)');

    if not cbxNfeCancelada.Checked then
      lListaFiltro.Add('(nfe_cancelada eq false)');

    if ((edtTransmissaoInicial.Text <> '') and (edtTransmissaoFinal.Text <> '')) then
    begin
      lListaFiltro.Add('((substring(nfe_transmissao, 1, 10) ge '+edtTransmissaoInicial.Text+') and ' +
        '(substring(nfe_transmissao, 1, 10) le '+edtTransmissaoFinal.Text+'))');
    end;

    lFiltroBanco := frmBanco.GetFilterDataBase;

    if not lFiltroBanco.IsEmpty then
      lListaFiltro.Add('(data_base_id eq '+lFiltroBanco+')');

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewNfeList.NfeDatasetnfe_esGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
  begin
    if Sender.AsInteger = 0 then
      Text := 'ENTRADA'
    else
      Text := 'SAÍDA';
  end;
end;

procedure TFViewNfeList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

function TFViewNfeList.ValidarDatas: string;
begin
  Result := EmptyStr;

  if (Trim(edtTransmissaoInicial.Text).IsEmpty) or (Trim(edtTransmissaoFinal.Text).IsEmpty) then
  begin
    Result := 'Data inicial e final são obrigatórias!';
    Exit;
  end;

  if edtTransmissaoInicial.Date > edtTransmissaoFinal.Date then
  begin
    Result := 'A data inicial deve ser menor que a final!';
    Exit;
  end;

  if DaysBetween(edtTransmissaoInicial.Date, edtTransmissaoFinal.Date) > 365 then
  begin
    Result := 'O intervalo entre as datas deve ser menor ou igual a 1 ano!';
    Exit;
  end;
end;

procedure TFViewNfeList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordNfeId : Integer;

  procedure BaixarArquivoButtonClick(Sender: TObject);
  var
    lBotaoSelecionado : TButton;
    lJson : TJSObject;
    lBotaoNome : string;
  begin
    TUtils.ChamarDivLoading;

    lBotaoSelecionado := TButton(Sender);
    lBotaoNome := lBotaoSelecionado.Name;

    lJson := TJSObject.New;

    if lBotaoNome = 'rbtBaixarXml'  then
      lJson['tipo'] := 'xml'
    else if lBotaoNome = 'rbtBaixarDanfe' then
      lJson['tipo'] := 'danfe';

    lJson['codigo'] := lBotaoSelecionado.Tag;
    lJson['tabela'] := 'nfe';

    XDataWebClient.RawInvoke('IService.BaixarArquivo', [lJson]);
  end;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
  lHabilitarDanfeXml : Boolean;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      NfeDataset.Connection.Model.DefaultSchema.FindEntityType(NfeDataset.EntitySetName),
      NfeDataset.CurrentData
    );

    RecordNfeId := NfeDataset.FieldByName('id').AsInteger;
    lHabilitarDanfeXml := not NfeDataset.FieldByName('xml_s3').AsString.IsEmpty and
      (NfeDataset.FieldByName('anexo_sincronizado').AsString = '1');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_nfe');

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarXml';
    Button.Tag := RecordNfeId;
    Button.Caption := '<i class="fas fa-file-code"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_xml');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar XML');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarDanfe';
    Button.Tag := RecordNfeId;
    Button.Caption := '<i class="fas fa-file-pdf"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_danfe');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar Danfe');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewNfeList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['valor_total', 'nfe_es',
     'nfe_lote.codigo']) of
      0: AClassName := 'text-end';
      1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewNfeList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'nfe_cancelada',
      'nfe_complementar']) of
      0, 1, 2:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>';
      end;
    end;
  end;
end;

procedure TFViewNfeList.WebFormCreate(Sender: TObject);
begin
  ConfigurarData;
  frmBanco.ConfigurarDataBase;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('nfe', 'active');
  TUtils.SetValorDicionarioClasses('documentos_fiscais_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_documentos_fiscais', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, NfeDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'codigo_interno desc';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNfeList.XDataWebClientError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewNfeList.XDataWebClientLoad(Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewNfeList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.nfe.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.nfe.list.table');
  cbPageSize := TComboBox.Create('view.nfe.list.cbPageSize');
  edSearch := TEdit.Create('view.nfe.list.search');
  lcPaginator := TListControl.Create('view.nfe.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  edtTransmissaoInicial := TDateTimePicker.Create('edtTransmissaoInicial');
  edtTransmissaoFinal := TDateTimePicker.Create('edtTransmissaoFinal');
  cbxNfeExcluidos := TCheckBox.Create('cbxNfeExcluidos');
  cbxNfeCancelada := TCheckBox.Create('cbxNfeCancelada');
  frmBanco := TfrmDataBase.Create(Self);
  btnPesquisarNfe := TButton.Create('btnPesquisarNfe');
  NfeDataset := TXDataWebDataSet.Create(Self);
  NfeDatasetcodigo_interno := TIntegerField.Create(Self);
  NfeDatasetchave_acesso := TStringField.Create(Self);
  NfeDatasetnfe_transmissao := TDateTimeField.Create(Self);
  NfeDatasetvalor_total := TFloatField.Create(Self);
  NfeDatasetnfe_es := TIntegerField.Create(Self);
  NfeDatasetnfe_cancelada := TBooleanField.Create(Self);
  NfeDatasetnfe_complementar := TBooleanField.Create(Self);
  NfeDatasetnfe_lotecodigo_interno := TIntegerField.Create(Self);
  NfeDatasetexcluido := TBooleanField.Create(Self);
  NfeDatasetinclusao := TDateTimeField.Create(Self);
  NfeDatasetalteracao := TDateTimeField.Create(Self);
  NfeDatasetexclusao := TDateTimeField.Create(Self);
  NfeDatasetxml_s3 := TStringField.Create(Self);
  NfeDatasetid := TIntegerField.Create(Self);
  NfeDatasetanexo_sincronizado := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  frmBanco.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  edtTransmissaoInicial.BeforeLoadDFMValues;
  edtTransmissaoFinal.BeforeLoadDFMValues;
  cbxNfeExcluidos.BeforeLoadDFMValues;
  cbxNfeCancelada.BeforeLoadDFMValues;
  frmBanco.BeforeLoadDFMValues;
  frmBanco.cbbDataBasePesquisa.BeforeLoadDFMValues;
  btnPesquisarNfe.BeforeLoadDFMValues;
  NfeDataset.BeforeLoadDFMValues;
  NfeDatasetcodigo_interno.BeforeLoadDFMValues;
  NfeDatasetchave_acesso.BeforeLoadDFMValues;
  NfeDatasetnfe_transmissao.BeforeLoadDFMValues;
  NfeDatasetvalor_total.BeforeLoadDFMValues;
  NfeDatasetnfe_es.BeforeLoadDFMValues;
  NfeDatasetnfe_cancelada.BeforeLoadDFMValues;
  NfeDatasetnfe_complementar.BeforeLoadDFMValues;
  NfeDatasetnfe_lotecodigo_interno.BeforeLoadDFMValues;
  NfeDatasetexcluido.BeforeLoadDFMValues;
  NfeDatasetinclusao.BeforeLoadDFMValues;
  NfeDatasetalteracao.BeforeLoadDFMValues;
  NfeDatasetexclusao.BeforeLoadDFMValues;
  NfeDatasetxml_s3.BeforeLoadDFMValues;
  NfeDatasetid.BeforeLoadDFMValues;
  NfeDatasetanexo_sincronizado.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'FViewNfeList';
    Width := 606;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 312;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 30;
    WebDBTableControl1.Width := 345;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 150;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'chave_acesso';
      Title := 'Chave Acesso';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfe_transmissao';
      Title := 'Transmiss'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfe_es';
      Title := 'Tipo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfe_cancelada';
      Title := 'nfe cancelada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfe_complementar';
      Title := 'nfe complementar';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfe_lote.codigo_interno';
      Title := 'Lote';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 3;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 232;
    edSearch.Top := 3;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 208;
    lcPaginator.Top := 301;
    lcPaginator.Width := 145;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 376;
    btnExportarExcel.Top := 30;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    edtTransmissaoInicial.SetParentComponent(Self);
    edtTransmissaoInicial.Name := 'edtTransmissaoInicial';
    edtTransmissaoInicial.Left := 376;
    edtTransmissaoInicial.Top := 61;
    edtTransmissaoInicial.Width := 120;
    edtTransmissaoInicial.Height := 22;
    edtTransmissaoInicial.BorderStyle := bsSingle;
    edtTransmissaoInicial.ChildOrder := 109;
    edtTransmissaoInicial.Color := clWhite;
    edtTransmissaoInicial.Date := 45980.718362395830000000;
    edtTransmissaoInicial.Role := '';
    edtTransmissaoInicial.Text := '';
    edtTransmissaoFinal.SetParentComponent(Self);
    edtTransmissaoFinal.Name := 'edtTransmissaoFinal';
    edtTransmissaoFinal.Left := 376;
    edtTransmissaoFinal.Top := 89;
    edtTransmissaoFinal.Width := 120;
    edtTransmissaoFinal.Height := 22;
    edtTransmissaoFinal.BorderStyle := bsSingle;
    edtTransmissaoFinal.ChildOrder := 109;
    edtTransmissaoFinal.Color := clWhite;
    edtTransmissaoFinal.Date := 45980.718362395830000000;
    edtTransmissaoFinal.Role := '';
    edtTransmissaoFinal.Text := '';
    cbxNfeExcluidos.SetParentComponent(Self);
    cbxNfeExcluidos.Name := 'cbxNfeExcluidos';
    cbxNfeExcluidos.Left := 376;
    cbxNfeExcluidos.Top := 117;
    cbxNfeExcluidos.Width := 120;
    cbxNfeExcluidos.Height := 22;
    cbxNfeExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxNfeExcluidos.ChildOrder := 9;
    cbxNfeExcluidos.HeightPercent := 100.000000000000000000;
    cbxNfeExcluidos.WidthPercent := 100.000000000000000000;
    cbxNfeCancelada.SetParentComponent(Self);
    cbxNfeCancelada.Name := 'cbxNfeCancelada';
    cbxNfeCancelada.Left := 376;
    cbxNfeCancelada.Top := 145;
    cbxNfeCancelada.Width := 120;
    cbxNfeCancelada.Height := 22;
    cbxNfeCancelada.Caption := 'Exibir Canceladas?';
    cbxNfeCancelada.ChildOrder := 9;
    cbxNfeCancelada.HeightPercent := 100.000000000000000000;
    cbxNfeCancelada.WidthPercent := 100.000000000000000000;
    frmBanco.SetParentComponent(Self);
    frmBanco.Name := 'frmBanco';
    frmBanco.Left := 376;
    frmBanco.Top := 173;
    frmBanco.Width := 215;
    frmBanco.Height := 61;
    frmBanco.TabOrder := 9;
    frmBanco.Visible := False;
    frmBanco.cbbDataBasePesquisa.Height := 21;
    btnPesquisarNfe.SetParentComponent(Self);
    btnPesquisarNfe.Name := 'btnPesquisarNfe';
    btnPesquisarNfe.Left := 376;
    btnPesquisarNfe.Top := 240;
    btnPesquisarNfe.Width := 96;
    btnPesquisarNfe.Height := 25;
    btnPesquisarNfe.Caption := 'Pesquisar';
    btnPesquisarNfe.ChildOrder := 11;
    btnPesquisarNfe.HeightPercent := 100.000000000000000000;
    btnPesquisarNfe.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarNfe, Self, 'OnClick', 'btnPesquisarNfeClick');
    NfeDataset.SetParentComponent(Self);
    NfeDataset.Name := 'NfeDataset';
    NfeDataset.EntitySetName := 'Nfe';
    NfeDataset.Connection := DMConnection.ApiConnection;
    NfeDataset.Left := 72;
    NfeDataset.Top := 80;
    NfeDatasetcodigo_interno.SetParentComponent(NfeDataset);
    NfeDatasetcodigo_interno.Name := 'NfeDatasetcodigo_interno';
    NfeDatasetcodigo_interno.FieldName := 'codigo_interno';
    NfeDatasetcodigo_interno.Required := True;
    NfeDatasetchave_acesso.SetParentComponent(NfeDataset);
    NfeDatasetchave_acesso.Name := 'NfeDatasetchave_acesso';
    NfeDatasetchave_acesso.FieldName := 'chave_acesso';
    NfeDatasetchave_acesso.Size := 255;
    NfeDatasetnfe_transmissao.SetParentComponent(NfeDataset);
    NfeDatasetnfe_transmissao.Name := 'NfeDatasetnfe_transmissao';
    NfeDatasetnfe_transmissao.FieldName := 'nfe_transmissao';
    NfeDatasetnfe_transmissao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetvalor_total.SetParentComponent(NfeDataset);
    NfeDatasetvalor_total.Name := 'NfeDatasetvalor_total';
    NfeDatasetvalor_total.FieldName := 'valor_total';
    NfeDatasetvalor_total.DisplayFormat := '#,##0.00';
    NfeDatasetnfe_es.SetParentComponent(NfeDataset);
    NfeDatasetnfe_es.Name := 'NfeDatasetnfe_es';
    NfeDatasetnfe_es.FieldName := 'nfe_es';
    SetEvent(NfeDatasetnfe_es, Self, 'OnGetText', 'NfeDatasetnfe_esGetText');
    NfeDatasetnfe_cancelada.SetParentComponent(NfeDataset);
    NfeDatasetnfe_cancelada.Name := 'NfeDatasetnfe_cancelada';
    NfeDatasetnfe_cancelada.FieldName := 'nfe_cancelada';
    NfeDatasetnfe_complementar.SetParentComponent(NfeDataset);
    NfeDatasetnfe_complementar.Name := 'NfeDatasetnfe_complementar';
    NfeDatasetnfe_complementar.FieldName := 'nfe_complementar';
    NfeDatasetnfe_complementar.Required := True;
    NfeDatasetnfe_lotecodigo_interno.SetParentComponent(NfeDataset);
    NfeDatasetnfe_lotecodigo_interno.Name := 'NfeDatasetnfe_lotecodigo_interno';
    NfeDatasetnfe_lotecodigo_interno.FieldName := 'nfe_lote.codigo_interno';
    NfeDatasetexcluido.SetParentComponent(NfeDataset);
    NfeDatasetexcluido.Name := 'NfeDatasetexcluido';
    NfeDatasetexcluido.FieldName := 'excluido';
    NfeDatasetinclusao.SetParentComponent(NfeDataset);
    NfeDatasetinclusao.Name := 'NfeDatasetinclusao';
    NfeDatasetinclusao.FieldName := 'inclusao';
    NfeDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetalteracao.SetParentComponent(NfeDataset);
    NfeDatasetalteracao.Name := 'NfeDatasetalteracao';
    NfeDatasetalteracao.FieldName := 'alteracao';
    NfeDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetexclusao.SetParentComponent(NfeDataset);
    NfeDatasetexclusao.Name := 'NfeDatasetexclusao';
    NfeDatasetexclusao.FieldName := 'exclusao';
    NfeDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetxml_s3.SetParentComponent(NfeDataset);
    NfeDatasetxml_s3.Name := 'NfeDatasetxml_s3';
    NfeDatasetxml_s3.Tag := 1;
    NfeDatasetxml_s3.FieldName := 'xml_s3';
    NfeDatasetxml_s3.Size := 65536;
    NfeDatasetid.SetParentComponent(NfeDataset);
    NfeDatasetid.Name := 'NfeDatasetid';
    NfeDatasetid.Tag := 1;
    NfeDatasetid.FieldName := 'id';
    NfeDatasetid.Required := True;
    NfeDatasetanexo_sincronizado.SetParentComponent(NfeDataset);
    NfeDatasetanexo_sincronizado.Name := 'NfeDatasetanexo_sincronizado';
    NfeDatasetanexo_sincronizado.Tag := 1;
    NfeDatasetanexo_sincronizado.FieldName := 'anexo_sincronizado';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := NfeDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 136;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 280;
    tmrConsulta.Top := 168;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClient, Self, 'OnLoad', 'XDataWebClientLoad');
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 472;
    XDataWebClient.Top := 256;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    edtTransmissaoInicial.AfterLoadDFMValues;
    edtTransmissaoFinal.AfterLoadDFMValues;
    cbxNfeExcluidos.AfterLoadDFMValues;
    cbxNfeCancelada.AfterLoadDFMValues;
    frmBanco.AfterLoadDFMValues;
    frmBanco.cbbDataBasePesquisa.AfterLoadDFMValues;
    btnPesquisarNfe.AfterLoadDFMValues;
    NfeDataset.AfterLoadDFMValues;
    NfeDatasetcodigo_interno.AfterLoadDFMValues;
    NfeDatasetchave_acesso.AfterLoadDFMValues;
    NfeDatasetnfe_transmissao.AfterLoadDFMValues;
    NfeDatasetvalor_total.AfterLoadDFMValues;
    NfeDatasetnfe_es.AfterLoadDFMValues;
    NfeDatasetnfe_cancelada.AfterLoadDFMValues;
    NfeDatasetnfe_complementar.AfterLoadDFMValues;
    NfeDatasetnfe_lotecodigo_interno.AfterLoadDFMValues;
    NfeDatasetexcluido.AfterLoadDFMValues;
    NfeDatasetinclusao.AfterLoadDFMValues;
    NfeDatasetalteracao.AfterLoadDFMValues;
    NfeDatasetexclusao.AfterLoadDFMValues;
    NfeDatasetxml_s3.AfterLoadDFMValues;
    NfeDatasetid.AfterLoadDFMValues;
    NfeDatasetanexo_sincronizado.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
